export function chatFormatters() {
  return {
    formatTime(isoString) {
      if (!isoString) return '';

      const locale = window.i18n?.language || 'en';
      const date = new Date(isoString);
      const now = new Date();
      const diff = now - date;

      if (diff < 86400000 && date.getDate() === now.getDate()) {
        return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
      }

      if (diff < 604800000) {
        return date.toLocaleDateString(locale, { weekday: 'long' });
      }

      return date.toLocaleDateString(locale, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
    },

    formatMessageTime(isoString) {
      if (!isoString) return '';
      const locale = window.i18n?.language || 'en';
      return new Date(isoString).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    shouldShowDateSeparator(messages, index) {
      if (index === 0) return true;
      if (!messages[index] || !messages[index - 1]) return false;

      const currentDate = new Date(messages[index].created_at).toDateString();
      const prevDate = new Date(messages[index - 1].created_at).toDateString();

      return currentDate !== prevDate;
    },

    formatDateSeparator(isoString) {
      if (!isoString) return '';

      const locale = window.i18n?.language || 'en';
      const t = (key) => window.i18n?.t(key) || key;
      const date = new Date(isoString);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      if (date.toDateString() === today.toDateString()) {
        return t('chat.formatters.today');
      }

      if (date.toDateString() === yesterday.toDateString()) {
        return t('chat.formatters.yesterday');
      }

      return date.toLocaleDateString(locale, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    },

    // Returns the best available text for a message, preferring the current
    // locale's field and falling back to the other language. A French-locale
    // user's message only populates content_fr (and vice versa), so reading
    // `content` alone would miss the text for messages in the other language.
    displayableContent(message) {
      if (!message) return '';
      return this.currentLocale === 'fr'
        ? (message.content_fr || message.content || '')
        : (message.content || message.content_fr || '');
    },

    lastMessagePreview(message) {
      const t = (key) => window.i18n?.t(key) || key;
      if (!message) return t('chat.formatters.no_messages_yet');

      const content = this.displayableContent(message);
      if (content) return content;

      const labels = {
        image: t('chat.formatters.photo'),
        video: t('chat.formatters.video'),
        audio: t('chat.formatters.audio'),
        file: t('chat.formatters.file'),
      };
      return labels[message.attachment_type] || t('chat.formatters.attachment');
    },

    GROUP_AVATAR_COLORS: [
      '#8A38F5',
      '#31863E',
      '#D22A2F',
      '#473F32',
      '#B3472D',
      '#2F7B6B',
      '#181937',
      '#997813'
    ],

    groupAvatarColor(id) {
      return this.GROUP_AVATAR_COLORS[id % this.GROUP_AVATAR_COLORS.length];
    }
  };
}